import { requestConstantsMaker } from '../helper';

/**** 20200217 ****/
export const UPDATE_APPLICATION_SESSION_STATUS = requestConstantsMaker('UPDATE_APPLICATION_SESSION_STATUS');
export const UPDATE_APPLICATION_SESSION_STATUS_BY_COURSE_SESSION_ID = requestConstantsMaker('UPDATE_APPLICATION_SESSION_STATUS_BY_COURSE_SESSION_ID');
export const RESCHEDULE_APPLICATION_SESSION = requestConstantsMaker('RESCHEDULE_APPLICATION_SESSION');
export const RESCHEDULE_COURSE_SESSION = requestConstantsMaker('RESCHEDULE_COURSE_SESSION');
export const CANCEL_APPLICATION_SESSION = requestConstantsMaker('CANCEL_APPLICATION_SESSION');
export const CANCEL_COURSE_SESSION = requestConstantsMaker('CANCEL_COURSE_SESSION');
export const SWAP_APPLICATION_SESSION = requestConstantsMaker('SWAP_APPLICATION_SESSION');
export const UPDATE_APPLICATION_SESSION_NUMBER = requestConstantsMaker('UPDATE_APPLICATION_SESSION_NUMBER');
/**** 20200217 ****/
